/**
 * Replaces mustache-style template variables ({{key}}) in a string with values from a dictionary
 * @param {string} template - The template string containing mustache-style variables
 * @param {Object.<string, string|number>} substitutions - Dictionary of key-value pairs for substitution
 * @returns {string} The template string with all variables replaced with their values
 * @example
 * const template = "Hello {{name}}, your balance is {{amount}}";
 * const values = { name: "John", amount: "$100" };
 * const result = replaceTemplateVars(template, values);
 * // result: "Hello John, your balance is $100"
 */
export const replaceTemplateVars = (template, substitutions) => {
  if (!template || typeof template !== 'string') {
    return '';
  }

  if (!substitutions || typeof substitutions !== 'object') {
    return template;
  }

  return template.replace(/\{\{([^}]+)\}\}/g, (match, key) => {
    const trimmedKey = key.trim();
    return substitutions[trimmedKey] !== undefined 
      ? String(substitutions[trimmedKey])
      : match;
  });
};
